import { useState } from "react";

/* -----------------Hooks--------------- */
import { DateTimePicker } from "components";

import { useExamContext } from "@features/exam";
/* -----------------Components--------------- */
import ChooseDateView from "../components/ChooseDateView";

const ChooseDateContainer = () => {
	const {
		updateExamDate,
		currentExamContext: { examDate },
	} = useExamContext();
	const [showDatePicker, setShowDatePicker] = useState(false);

	const toggleDatePicker = () => {
		setShowDatePicker(!showDatePicker);
	};

	return (
		<>
			<ChooseDateView
				selectedExamDate={examDate}
				toggleDatePicker={() => setShowDatePicker(true)}
			/>
			{showDatePicker ? (
				<DateTimePicker
					isVisible
					onCancel={toggleDatePicker}
					onConfirm={(date) => {
						toggleDatePicker();
						updateExamDate(date);
					}}
				/>
			) : null}
		</>
	);
};

export default ChooseDateContainer;
